// import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
// import { ApiResponse, AvailableFunctionParams } from '../../data/system/function';
// import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { env } from '../../../app.constant';
// import { tap } from 'rxjs/operators';
import { FunctionData } from '../../data/system/function';

@Injectable()
export class FunctionService extends FunctionData {

  // constructor(private http: HttpClient) { super(); }

  // getAvailableFunction(params: AvailableFunctionParams): Observable<ApiResponse> {
  //   const host = `${env.host}${env.endpoint.function_available_get}`;
  //   return this.http.post<ApiResponse>(host, params).pipe(
  //     tap(data => console.log(`getAvailableFunction->data`, data))
  //   );
  // }

}
